/**
 * Lottie Logo Animation for Ward Hero Banner
 * Replicates the pb-row-splash-page__lottie animation
 */

(function() {
  'use strict';

  // Lottie animation configuration
  const LOTTIE_CONFIG = {
    renderer: 'svg',
    loop: false,
    autoplay: true,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid meet',
      clearCanvas: true,
      progressiveLoad: false,
      hideOnTransparent: true
    }
  };

  // Initialize Lottie animation
  function initLottieAnimation() {
    // Check if Lottie library is available
    if (typeof lottie === 'undefined') {
      console.warn('Lottie library not found. Loading from CDN...');
      loadLottieLibrary().then(() => {
        initLottieAnimation();
      });
      return;
    }

    // Find the Lottie container in the hero banner
    const lottieContainer = document.querySelector('.pb-row-splash-page__lottie');
    if (!lottieContainer) {
      console.warn('Lottie container not found');
      return;
    }

    // Load and play Lottie animation
    loadLottieAnimation(lottieContainer);
  }

  // Load Lottie animation
  function loadLottieAnimation(container) {
    const lottiePath = container.getAttribute('data-lottie');
    const delay = parseInt(container.getAttribute('data-lottie-delay') || '0', 10);
    const autoplay = container.getAttribute('data-lottie-autoplay') === 'true';
    const loop = container.getAttribute('data-lottie-loop') === 'true';
    const renderer = container.getAttribute('data-lottie-renderer') || 'svg';

    // Create animation instance
    const animation = lottie.loadAnimation({
      container: container,
      path: lottiePath,
      renderer: renderer,
      loop: loop,
      autoplay: false, // We'll control playback manually
      rendererSettings: LOTTIE_CONFIG.rendererSettings
    });

    // Store animation instance
    container.lottieAnimation = animation;

    // Handle animation events
    animation.addEventListener('DOMLoaded', () => {
      container.classList.add('lottie-loaded');
    });

    animation.addEventListener('complete', () => {
      container.classList.add('lottie-complete');
    });

    // Play animation after delay
    setTimeout(() => {
      if (autoplay) {
        animation.play();
        container.classList.add('is-playing');
      }
    }, delay);

    // Handle scroll-based animation
    setupScrollAnimation(container, animation);
  }

  // Setup scroll-based animation triggers
  function setupScrollAnimation(container, animation) {
    // Check if scroll system exists
    const hasScrollSystem = window.emitter || 
                           (window.Site && window.Site.emitter) ||
                           (window.App && window.App.emitter);

    if (hasScrollSystem) {
      const emitter = window.emitter || 
                     (window.Site && window.Site.emitter) ||
                     (window.App && window.App.emitter);

      // Listen for scroll events
      emitter.on('SiteScroll.lottie', (inView, scrollData) => {
        if (scrollData && scrollData.el === container) {
          handleScrollAnimation(container, animation, inView, scrollData);
        }
      });
    }

    // Fallback: Use Intersection Observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          container.classList.add('is-inview');
          if (!container.classList.contains('is-playing')) {
            animation.play();
            container.classList.add('is-playing');
          }
        } else {
          container.classList.remove('is-inview');
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px'
    });

    observer.observe(container);
  }

  // Handle scroll-based animation
  function handleScrollAnimation(container, animation, inView, scrollData) {
    if (inView) {
      container.classList.add('is-inview');
      if (!container.classList.contains('is-playing')) {
        animation.play();
        container.classList.add('is-playing');
      }

      // Update transform based on scroll progress
      if (scrollData && scrollData.progress !== undefined) {
        const progress = scrollData.progress;
        const scale = 1 - (progress * 0.2); // Scale down slightly as you scroll
        const translateY = progress * 50; // Move down slightly
        const opacity = 1 - (progress * 0.3); // Fade slightly

        container.style.transform = `scale(${Math.max(0.8, scale)}) translateY(${translateY}px)`;
        container.style.opacity = Math.max(0.7, opacity);
      }
    } else {
      container.classList.remove('is-inview');
    }
  }

  // Load Lottie library from CDN if not available
  function loadLottieLibrary() {
    return new Promise((resolve, reject) => {
      if (typeof lottie !== 'undefined') {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js';
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Failed to load Lottie library'));
      document.head.appendChild(script);
    });
  }

  // Initialize when DOM is ready
  function init() {
    // Wait a bit for any existing Lottie initialization
    setTimeout(() => {
      initLottieAnimation();
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose for manual initialization
  window.initWardHeroLottie = initLottieAnimation;
})();

